import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import Image from 'next/image';
import { Modal } from 'antd';
import style from './index.module.scss';

const Player = (props: any, ref: React.Ref<unknown>) => {
  const [videoVisible, setVideoVisible] = useState(false);
  const [mp4Url, setMp4Url] = useState('');
  const videoRef = useRef<HTMLVideoElement>(null);
  const playVideo = (value: boolean) => {
    if (value) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
    setVideoVisible(value);
  };
  useImperativeHandle(ref, () => ({
    play: (url: string) => {
      setMp4Url(url);
      playVideo(true);
    },
  }));
  return (
    <div>
      <Modal
        title=" "
        closeIcon={<Image className={style.closeIcon} src="/v2/images/home/live-closer.png" alt="font" layout="fill" />}
        visible={videoVisible}
        centered={true}
        footer={null}
        className={style.videoModal}
        onCancel={() => playVideo(false)}
      >
        <video ref={videoRef} className={style.videoPlayer} controls autoPlay src={mp4Url}>
          您的浏览器不支持video
        </video>
      </Modal>
    </div>
  );
};

export default forwardRef(Player);
